import { render } from "./EditProcedure.vue?vue&type=template&id=0cff8889&scoped=true"
import script from "./EditProcedure.vue?vue&type=script&lang=js"
export * from "./EditProcedure.vue?vue&type=script&lang=js"

import "./EditProcedure.vue?vue&type=style&index=0&id=0cff8889&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cff8889"]])

export default __exports__